import React from 'react';
import classNames from 'classnames';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SubmenuNavigationItemUi_ViewerVersion1 = ({
  href,
  target,
  title,
  onATagClick,
  selected,
  submenuItem
})=> (
  <div className={classNames(`submenu-nav-link-wrapper desktop-submenu-item-${submenuItem.id}`, {
    'submenu-selected': selected
  })}>

    <a
      href={href}
      target={target}
      onClick={onATagClick}
      className="action-nav-link submenu-nav-link"
    >

      <span className="submenu-nav-link-inner">
        {title}
      </span>

    </a>
  </div>
);

const SubmenuNavigationItemUi_ViewerVersion2 = ({
  href,
  target,
  title,
  selected,
  submenuItem,
  shouldShowExternalOpeningMsg,
  onATagClick,
})=> (
  <li className={classNames(`submenu-nav-link-wrapper desktop-submenu-item-${submenuItem.id}`, {
    'submenu-selected': selected
  })}>

    <a
      href={href}
      target={target}
      onClick={onATagClick}
      className={classNames('action-nav-link submenu-nav-link', {
        'zf-external-link': shouldShowExternalOpeningMsg
      })}
    >

      <span className="submenu-nav-link-inner">
        {title}

        {
          shouldShowExternalOpeningMsg &&
            <span className="opens-in-external-view-wrapper">
              Opens in a new window
            </span>
        }
      </span>

    </a>
  </li>
);

const SubmenuNavigationItemUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SubmenuNavigationItemUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SubmenuNavigationItemUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SubmenuNavigationItemUi;
